import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainerWrapper } from './utils/toastConfig';
import { useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import ProtectedLayout from './layouts/ProtectedLayout';
import logo from './assets/logo.png';

/**
 * This is the root component of the application.
 * It now only shows the login page to unauthenticated users,
 * as public registration is disabled.
 */
function App() {
    const { user, loading } = useAuth();

    useEffect(() => {
        const link = document.querySelector("link[rel~='icon']");
        if (link) {
            link.href = logo;
        } else {
            const newLink = document.createElement('link');
            newLink.rel = 'icon';
            newLink.href = logo;
            document.head.appendChild(newLink);
        }
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100">
                <div className="text-center">
                    <div className="mx-auto w-16 h-16 bg-primary-600 rounded-2xl flex items-center justify-center mb-6 animate-pulse">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                    </div>
                    <h1 className="text-2xl font-bold text-neutral-900 mb-2">AP Automate</h1>
                    <p className="text-neutral-600">Loading your accounts payable system...</p>
                    <div className="mt-6 flex justify-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
                    </div>
                </div>
            </div>
        );
    }

    // If a user is logged in, show the protected layout. Otherwise, show the login page.
    return (
        <>
            <ToastContainerWrapper />
            <Router>
                {user ? <ProtectedLayout /> : <LoginPage />}
            </Router>
        </>
    );
}

export default App;

